<template>
  <div v-if="!mustRedirect">
    <section class="itb-graphic-detail">
      <div class="container">
        <div class="row mb-3" v-if="prevGraphic && nextGraphic">
          <div class="col-md-6">
            <router-link :to="{
              name: 'graphicDetail',
              params: {
                categoryAlias: prevGraphic.categoryAlias,
                subcategoryAlias: prevGraphic.subcategoryAlias,
                subcategory2Alias: prevGraphic.subcategory2Alias,
                graphicAlias: prevGraphic.id + '-' + prevGraphic.alias,
                scrollToElementId: 'itb-breadcrumbs',
              },
            }" class="itb-link">
              <img src="/images/icons/4soft_icon_angle-left-blue.svg" alt="Přejít na Smajlík - mrkající 30cm"
                class="itb-icon itb-angle-down-icon" />
              <span> {{ $t("graphics.previous_graphic") }}</span>
            </router-link>
          </div>
          <div class="col-md-6 text-right">
            <router-link :to="{
              name: 'graphicDetail',
              params: {
                categoryAlias: nextGraphic.categoryAlias,
                subcategoryAlias: nextGraphic.subcategoryAlias,
                subcategory2Alias: nextGraphic.subcategory2Alias,
                graphicAlias: nextGraphic.id + '-' + nextGraphic.alias,
                scrollToElementId: 'itb-breadcrumbs',
              },
            }" class="itb-link itb-right">
              <span> {{ $t("graphics.next_graphic") }}</span>
              <img src="/images/icons/4soft_icon_angle-right-blue.svg" alt="Přejít na Smajlík - mrkající 30cm"
                class="itb-icon itb-angle-down-icon" />
            </router-link>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-xl-2 itb-main-image text-center">
            <img v-if="selectedImage.src" :src="selectedImage.src" :alt="graphic.name_variant" />
            <div v-if="carouselImages.length > 1" class="itb-carousel-detail">
              <img v-if="carouselImages.length > maxVisibleImages" :src="referenceIndexStart <= 0
                ? '/images/icons/4soft_icon_angle-left-gray.svg'
                : '/images/icons/4soft_icon_angle-left-blue.svg'
                " alt="Přejít na Smajlík - mrkající 30cm" class="itb-icon itb-angle-down-icon"
                @click="decreaseVisibleImageIndexes" />
              <img class="itb-carousel-detail-img" :class="{
                'ml-0': cDetailIndex === 0,
                'itb-selected-carousel-img':
                  selectedImage.id === vCarouselImg.id,
              }" v-for="(vCarouselImg, cDetailIndex) in visibleCarouselImages"
                :key="'carousel-image-' + vCarouselImg.id" :alt="'carousel-image-' + vCarouselImg.id"
                :src="vCarouselImg.reducedImageSrc" @click="setMainImage(vCarouselImg)" />
              <img v-if="carouselImages.length > maxVisibleImages" :src="referenceIndexStart >= maxIndexForVisibleImages
                ? '/images/icons/4soft_icon_angle-right-gray.svg'
                : '/images/icons/4soft_icon_angle-right-blue.svg'
                " alt="Přejít na Smajlík - mrkající 30cm" class="itb-icon itb-angle-down-icon"
                @click="increaseVisibleImageIndexes" />
            </div>
          </div>
          <div class="col-12 col-xl-10 itb-main-content">
            <div class="row">
              <div class="col-12">
                <h2 style="margin-bottom: 1.15rem" class="text-center text-md-left">
                  {{ graphic.name_variant }}
                </h2>
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-md-7 itb-graphic-values">
                <div class="row">
                  <div v-if="!(isResponsiveLg && !graphic.code)" class="col-12 col-lg-6">
                    <div class="itb-input-like-group itb-margin-bottom" :class="{
                      'itb-missing-field': !graphic.code,
                    }">
                      <div class="itb-label">
                        {{ $t("graphics.code") }}
                      </div>
                      <div class="itb-text">
                        <span class="itb-font-black">{{
                          graphic.code ? graphic.code : "-"
                        }}</span>
                      </div>
                    </div>
                  </div>
                  <div v-if="!(isResponsiveLg && !graphic.weight)" class="col-12 col-lg-6">
                    <div class="itb-input-like-group itb-margin-bottom" :class="{
                      'itb-missing-field': !graphic.weight,
                    }">
                      <div class="itb-label">
                        {{ $t("graphics.weight") }}
                      </div>
                      <div class="itb-text">
                        <span class="itb-font-black">{{ graphic.weight ? graphic.weight + " kg" : "-" }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div v-if="!(isResponsiveLg && !graphic.height)" class="col-12 col-lg-6">
                    <div class="itb-input-like-group itb-margin-bottom" :class="{
                      'itb-missing-field': !graphic.height,
                    }">
                      <div class="itb-label">
                        {{ $t("graphics.height") }}
                      </div>
                      <div class="itb-text">
                        <span class="itb-font-black">{{ graphic.height ? graphic.height + " cm" : "-" }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div v-if="!(isResponsiveLg && !graphic.diameter)" class="col-12 col-lg-6">
                    <div class="itb-input-like-group itb-margin-bottom" :class="{
                      'itb-missing-field': !graphic.diameter,
                    }">
                      <div class="itb-label">
                        {{ $t("graphics.diameter") }}
                      </div>
                      <div class="itb-text">
                        <span class="itb-font-black">{{
                          graphic.diameter ? graphic.diameter + " cm" : "-"
                        }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div v-if="!(isResponsiveLg && !graphic.width)" class="col-12 col-lg-6">
                    <div class="itb-input-like-group itb-margin-bottom" :class="{
                      'itb-missing-field': !graphic.width,
                    }">
                      <div class="itb-label">
                        {{ $t("graphics.width") }}
                      </div>
                      <div class="itb-text">
                        <span class="itb-font-black">{{ graphic.width ? graphic.width + " cm" : "-" }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div v-if="!(isResponsiveLg && !graphic.surface)" class="col-12 col-lg-6">
                    <div class="itb-input-like-group itb-margin-bottom" :class="{
                      'itb-missing-field': !graphic.surface,
                    }">
                      <div class="itb-label">
                        {{ $t("graphics.surface") }}
                      </div>
                      <div class="itb-text">
                        <span v-if="graphic.surface" class="itb-font-black">{{ graphic.surface + " " }}m<sup>2</sup>
                        </span>
                        <span v-else class="itb-font-black">-</span>
                      </div>
                    </div>
                  </div>
                  <div v-if="!(isResponsiveLg && !graphic.length)" class="col-12 col-lg-6">
                    <div class="itb-input-like-group itb-margin-bottom" :class="{
                      'itb-missing-field': !graphic.length,
                    }">
                      <div class="itb-label">
                        {{ $t("graphics.length") }}
                      </div>
                      <div class="itb-text">
                        <span class="itb-font-black">{{ graphic.length ? graphic.length + " cm" : "-" }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div v-if="!(isResponsiveLg && !graphic.volume)" class="col-12 col-lg-6">
                    <div class="itb-input-like-group itb-margin-bottom" :class="{
                      'itb-missing-field': !graphic.volume,
                    }">
                      <div class="itb-label">
                        {{ $t("graphics.volume") }}
                      </div>
                      <div class="itb-text">
                        <span v-if="graphic.volume" class="itb-font-black">{{ graphic.volume + " "
                          }}cm<sup>3</sup></span>
                        <span v-else class="itb-font-black">-</span>
                      </div>
                    </div>
                  </div>
                  <div v-if="
                    !(
                      isResponsiveLg &&
                      (!graphic.colors || !graphic.colors.length)
                    )
                  " class="col-12">
                    <div class="itb-input-like-group" :class="{
                      'itb-missing-field':
                        !graphic.colors || !graphic.colors.length,
                    }">
                      <div class="itb-label">
                        {{ $t("graphics.used_colors") }}
                      </div>
                      <div v-if="graphic.colors && graphic.colors.length" class="itb-text">
                        <span v-for="color in graphic.colors" :key="color.id" :class="color.filter_color_id != 11
                          ? 'itb-color-box font-weight-bold mr-2'
                          : 'font-weight-bold'
                          " :style="color.filter_color_id != 11
                            ? 'background-color: ' + color.color_code
                            : null
                            ">{{
                              color.filter_color_id == 11 ? "Na přání" : ""
                            }}</span>
                      </div>
                      <div v-else class="itb-text">
                        <span class="itb-font-black">-</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-5 itb-graphic-info">
                <h3 class="text-left itb-color-blue">
                  {{ $t("graphics.description") }}
                </h3>
                <p class="itb-subtext">
                  {{ graphic.description }}
                </p>
                <h3 class="text-left itb-color-blue" v-if="graphic.hashtags && graphic.hashtags.length">
                  {{ $t("graphics.hashtags") }}
                </h3>
                <p class="itb-subtext mb-0" v-if="graphic.hashtags && graphic.hashtags.length">
                  <span v-for="hashtag in graphic.hashtags" :key="hashtag.id" class="font-weight-bold mr-3">#{{
                    hashtag.name }}</span>
                </p>
              </div>
            </div>
          </div>
        </div>

        <section class="itb-graphics pt-0">
          <div v-if="
            graphic.otherGraphicTypes &&
            Object.keys(graphic.otherGraphicTypes).length > 1
          " class="mb-5">
            <h3 class="text-left text-md-center itb-color-blue">
              {{ $t("graphics.product_types") }}
            </h3>
            <div class="itb-graphics-items">
              <carousel :items="graphic.otherGraphicTypes" :graphic="graphic"></carousel>
            </div>
          </div>

          <div v-if="
            graphic.otherGraphicColors &&
            Object.keys(graphic.otherGraphicColors).length > 1
          " class="mb-5">
            <h3 class="text-left text-md-center itb-color-blue">
              {{ $t("graphics.color_variants") }}
            </h3>
            <div class="itb-graphics-items">
              <carousel :items="graphic.otherGraphicColors" :graphic="graphic"></carousel>
            </div>
          </div>
        </section>

        <div class="row text-center itb-references-alike-set" v-if="graphic.gallery && graphic.gallery.length">
          <div class="col-12">
            <h3 class="text-left text-md-center itb-color-blue">
              {{ $t("graphics.usecase_gallery") }}
            </h3>
          </div>

          <div class="col-12 col-md-4" v-for="image in graphic.gallery" :key="image.id">
            <div class="card w-100 itb-margin-bottom itb-lazy-loading-bg" v-lazy:background-image="image ? '/uploads/' + image.path + '/' + image.name : null
              " :title="image.description">
              <div class="card-body d-flex p-0">
                <div v-if="image.description" class="itb-text align-self-end w-100" style="padding: 1rem 0">
                  <h4 class="mb-0">
                    {{ image.description }}
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>

        <section class="itb-download-list row pb-0" v-if="graphic.downloads && graphic.downloads.length">
          <div class="col-12 mb-0">
            <div class="row mx-md-auto text-center itb-wrapper-row">
              <div class="col-12 mb-0">
                <h3 class="text-left text-md-center itb-color-blue">
                  {{ $t("graphics.donwloads") }}
                </h3>
              </div>
              <div v-for="download in graphic.downloads" :key="download.id" class="col-12 col-md-4">
                <div class="card w-100 h-100">
                  <div class="card-body d-flex align-items-center">
                    <div>
                      <span>{{ download.description }}</span>
                    </div>
                    <div class="itb-content">
                      <div>
                        <a :href="'/uploads/' + download.path + '/' + download.name
                          " class="ml-auto" download v-if="download.path">
                          <span>{{ $t("downloads.download") }}</span>
                          <img src="/images/icons/4soft_icon_download_blue.svg" :alt="$t('general.button') +
                            ' ' +
                            $t('downloads.download')
                            " class="itb-icon itb-download-icon" />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section v-if="(sketchLinks && !isSketchError) || isSketchError" class="itb-3d-model">
          <div class="col-12 mt-3">
            <h3 class="text-left text-md-center itb-color-blue">
              {{ $t("graphics.detail.3d_model") }}
            </h3>
          </div>
          <div v-if="graphic && sketchLinks && !isSketchError" class="sketchfab-embed-wrapper"> <iframe
              title="EPDM Mushroom´s house (P1-01A-20)" frameborder="0" allowfullscreen mozallowfullscreen="true"
              webkitallowfullscreen="true" allow="autoplay; fullscreen; xr-spatial-tracking" xr-spatial-tracking
              execution-while-out-of-viewport execution-while-not-rendered web-share :src="sketchLinks.iframeLink">
            </iframe>
            <p style="font-size: 13px; font-weight: normal; margin: 5px; color: #4A4A4A;"> <a :href="sketchLinks.href1"
                target="_blank" rel="nofollow" style="font-weight: bold; color: #1CAAD9;">{{ graphic.name_variant + ' ('
                  + graphic.code + ') ' }}</a> by <a :href="sketchLinks.href2" target="_blank" rel="nofollow"
                style="font-weight: bold; color: #1CAAD9;"> 4soft s.r.o. </a> on <a :href="sketchLinks.href3"
                target="_blank" rel="nofollow" style="font-weight: bold; color: #1CAAD9;">Sketchfab</a></p>
          </div>
          <div v-if="isSketchError" class="container">
            <div class="row">
              <div class="col-12 col-sm-8 offset-sm-2 col-md-4 col-lg-4 offset-md-4 offset-lg-4 pt-3 mb-5 text-center">
                <div class="alert itb-alert alert-info" role="alert">
                  {{ $t("graphics.detail.3d_model_not_available") }}
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </section>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      pageParams: [],
      graphic: [],
      prevGraphic: null,
      nextGraphic: null,
      mustRedirect: false,
      isResponsiveLg: false,
      carouselImages: [],
      visibleCarouselImages: [],
      selectedImage: { id: 0, src: "" },
      referenceIndexStart: 0,
      maxIndexForVisibleImages: 0,
      maxVisibleImages: 3,

      sketchLinks: null,
      isSketchError: false,
    };
  },

  watch: {
    $route(to, from) {
      this.getData();
    },
  },

  created() {
    this.onResize();
    window.addEventListener("resize", this.onResize);
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },

  mounted() {
    this.getData();
  },

  computed: {
    ...mapGetters({
      appParams: "getAppParams",
    }),
  },

  methods: {
    ...mapActions(["setPageParams"]),

    async getData() {
      await axios
        .get(
          `/getGraphicDetailPage/${this.$route.params.categoryAlias}/${this.$route.params.subcategoryAlias
          }/${this.$route.params.graphicAlias.split("-")[0]}`
        )
        .then((response) => {
          if (response.data.redirect == "redirect") {
            this.$router.push("/grafika");
          }

          this.pageParams = response.data.params;
          this.graphic = response.data.graphic;
          this.prevGraphic = response.data.prevGraphic;
          this.nextGraphic = response.data.nextGraphic;

          this.assignVisibleCarouselImages();

          this.setPageParams(this.pageParams);

          this.checkSkech3dUrl();

        })
        .catch((error) => {
          console.log(error);
        });
    },

    async checkSkech3dUrl() {
      await axios
        .post(
          `/get-sketch-3d-urls`,
          {
            graphicId: this.$route.params.graphicAlias.split("-")[0],
          }
        )
        .then((response) => {
          if (response.data.links) {
            this.sketchLinks = response.data.links;
          } else {
            this.sketchLinks = null;
          }

          if (response.data.isError) {
            this.isSketchError = response.data.isError;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    assignVisibleCarouselImages() {
      this.carouselImages = [];
      if (this.graphic.image) {
        this.carouselImages.push({
          id: this.graphic.image.id,
          imageSrc:
            "/uploads/" +
            this.graphic.image.path +
            "/" +
            this.graphic.image.name,
          reducedImageSrc:
            "/uploads/" +
            this.graphic.image.path +
            "/" +
            this.graphic.image.name,
        });
      }

      this.graphic.carouselDetail.forEach((cDetail, index) => {
        this.carouselImages.push({
          id: cDetail.id,
          imageSrc: "/uploads/" + cDetail.path + "/" + cDetail.name,
          reducedImageSrc: "/uploads/" + cDetail.path + "/sm_" + cDetail.name,
        });
      });

      if (this.carouselImages.length > 0) {
        this.setCarousel();
      }
    },

    setCarousel(mustChangeMainImage = true) {
      this.referenceIndexStart = 0;
      this.setMaxIndexForVisibleImages();
      this.changeVisibleCarouselImages(this.referenceIndexStart);

      // if (mustChangeMainImage) {
      this.setMainImage(this.visibleCarouselImages[0]);
      // }
    },

    changeVisibleCarouselImages(index) {
      this.visibleCarouselImages = this.carouselImages.slice(
        index,
        index + this.maxVisibleImages
      );
    },

    setMainImage(image) {
      this.selectedImage.src = image.imageSrc;
      this.selectedImage.id = image.id;
    },

    setMaxIndexForVisibleImages() {
      this.maxIndexForVisibleImages =
        this.carouselImages.length - this.maxVisibleImages >= 0
          ? this.carouselImages.length - this.maxVisibleImages
          : 0;
    },

    increaseVisibleImageIndexes() {
      this.referenceIndexStart++;

      if (this.referenceIndexStart > this.maxIndexForVisibleImages) {
        this.referenceIndexStart = this.maxIndexForVisibleImages;
      }

      this.changeVisibleCarouselImages(this.referenceIndexStart);
    },

    decreaseVisibleImageIndexes() {
      this.referenceIndexStart--;

      if (this.referenceIndexStart < 0) {
        this.referenceIndexStart = 0;
      }

      this.changeVisibleCarouselImages(this.referenceIndexStart);
    },

    onResize() {
      if (window.innerWidth < 992) {
        this.isResponsiveLg = true;
      } else {
        this.isResponsiveLg = false;
      }

      const previousMaxVisibleImages = this.maxVisibleImages;
      if (window.innerWidth >= 1200 && window.innerWidth < 1570) {
        this.maxVisibleImages = 2;
      } else {
        this.maxVisibleImages = 3;
      }

      if (
        previousMaxVisibleImages !== this.maxVisibleImages &&
        this.carouselImages.length > 0
      ) {
        this.setCarousel(false);
      }
    },
  },
};
</script>
